import { Buildings } from "@phosphor-icons/react";

const TONE = {
  blue:    { bg: "bg-blue-50",    text: "text-blue-700",    border: "border-blue-200" },
  amber:   { bg: "bg-amber-50",   text: "text-amber-700",   border: "border-amber-200" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200" },
  rose:    { bg: "bg-rose-50",    text: "text-rose-700",    border: "border-rose-200" },
  indigo:  { bg: "bg-indigo-50",  text: "text-indigo-700",  border: "border-indigo-200" },
  slate:   { bg: "bg-slate-50",   text: "text-slate-700",   border: "border-slate-200" },
};

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const KpiCard = ({ icon: Icon, label, value, tone = "slate", money = false, testId }) => {
  const t = TONE[tone] || TONE.slate;
  return (
    <div data-testid={testId} className={`bg-white border ${t.border} p-5 rounded-none shadow-sm hover:shadow-md transition-shadow`}>
      {Icon && (
        <div className={`w-9 h-9 ${t.bg} flex items-center justify-center mb-3`}>
          <Icon size={18} weight="bold" className={t.text} />
        </div>
      )}
      <div className="text-2xl lg:text-3xl font-bold text-slate-900 tabular-nums" style={{fontFamily: 'Outfit, sans-serif'}}>
        {money ? formatINR(value) : (value ?? 0)}
      </div>
      <div className="text-xs uppercase tracking-wider text-slate-500 mt-1.5">{label}</div>
    </div>
  );
};

export const DashboardHeader = ({ overline, title, subtitle, onRefresh, refreshTestId = "dash-refresh-btn", actions = null }) => (
  <div className="flex justify-between items-start mb-8 flex-wrap gap-4">
    <div>
      {overline && <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-1">{overline}</div>}
      <h1 className="text-4xl sm:text-5xl tracking-tighter leading-none font-bold mb-2" style={{fontFamily: 'Outfit, sans-serif'}}>
        {title}
      </h1>
      {subtitle && <p className="text-base leading-relaxed text-slate-700">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-3">
      {actions}
      {onRefresh && (
        <button data-testid={refreshTestId} onClick={onRefresh} className="rounded-none bg-[#002FA7] text-white hover:bg-[#00227A] px-5 py-2.5 font-medium transition-colors">
          Refresh
        </button>
      )}
    </div>
  </div>
);

export const SectionTable = ({ title, icon: Icon = Buildings, columns, rows, emptyText = "No data", testId, renderRow }) => (
  <div className="bg-white border border-slate-200 rounded-none shadow-sm mb-6">
    <div className="border-b border-slate-200 px-5 py-3 flex items-center gap-2">
      <Icon size={16} weight="bold" className="text-[#002FA7]" />
      <h3 className="text-sm uppercase tracking-[0.2em] font-bold text-slate-700">{title}</h3>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full" data-testid={testId}>
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200">
            {columns.map((c) => (
              <th key={c.key || c.label} className={`p-3 text-xs uppercase tracking-wider font-bold text-slate-500 ${c.align === "right" ? "text-right" : "text-left"}`}>
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(rows || []).length === 0 ? (
            <tr><td colSpan={columns.length} className="p-8 text-center text-slate-400 text-sm">{emptyText}</td></tr>
          ) : (
            (rows || []).map((r, i) => renderRow(r, i))
          )}
        </tbody>
      </table>
    </div>
  </div>
);
